import { ProjectServiceId, ProjectServiceResponse } from '../project';

export type TimeMaterialTemplateId = string;

export enum TimeMaterialTemplateType {
  main = 'main',
  jobCost = 'job_cost',
}

export interface TemplateStepResponse {
  id: number;
  name: string;
  menuOrder: number;
  link: string | null;
  instructions: string | null;
  assignedTo: string | null;
  parentId?: number;
  completedAt: number;
  subSteps: TemplateStepResponse[];
}

export interface TemplateSectionResponse {
  id: number;
  name: string;
  menuOrder: number;
  isPublic: boolean;
  steps: TemplateStepResponse[];
}

export interface TimeMaterialTemplateResponse {
  id: TimeMaterialTemplateId;
  name: string;
  description: string;
  details?: string;
  dueDays: number;
  jobType: Pick<ProjectServiceResponse, 'id' | 'title'> | null;
  boards: string[];
  sections: TemplateSectionResponse[];
  type: TimeMaterialTemplateType;
}

export type CompactTimeMaterialTemplateResponse = Omit<TimeMaterialTemplateResponse, 'sections'>;

export type TimeMaterialTemplateRequest = Pick<TimeMaterialTemplateResponse, 'name' | 'description' | 'dueDays' | 'boards' | 'details'>;
